import { NewRaffle } from "../../containers/screens/NewRaffle";

export default function Create() {
  return <NewRaffle />;
}
